import styled from 'styled-components'

export const Container = styled.div`
	form {
		display: grid !important;
		justify-items: center;
		align-items: center;
		grid-template-columns: 1fr 1fr;
		grid-template-rows: 40px auto auto auto auto;
		grid-template-areas:
			'declaracao valor_integral'
			'declaracao valor_desconto'
			'termo termo'
			'check check'
			'button button';

		> .file {
			grid-area: declaracao;
			justify-self: left;

			.file-select-area {
				background-position-y: top;
			}
		}

		> p {
			font-size: 16px;
			width: calc(100% - 16px);
			margin: 24px 8px;
			align-self: baseline;
		}

		@media(max-width: 650px) {
			grid-template-columns: 1fr;
			grid-template-rows: auto auto auto auto auto;
			grid-template-areas:
				'declaracao'
				'valor_integral'
				'valor_desconto'
				'termo'
				'check'
				'button';
		}
	}
`

export const TermoContainer = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	grid-area: termo;
	margin-top: 20px;
`

export const ModalTermoContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;

	iframe {
		width: calc(100% - 16px);
		height: 80vh;
	}
`
